import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class AccountingConfigurationBrandActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/Brand/BrandBrowser")
	}

	render() {
		return (
			<Activity 
				name="AccountingConfigurationBrand"
				RenderedComponent={this.RenderedComponent}
				context="AccountingConfigurationBrand"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(AccountingConfigurationBrandActivity)
